import React, { useEffect, useState } from 'react';
import { Divider } from "antd";

interface DailyUsageTabPrams {
    DailyUsage: any;
    DailyUsageChange: (value: any) => void;
}

export const DailyUsageTab = ({ DailyUsage, DailyUsageChange, disabled }: DailyUsageTabPrams & { disabled?: boolean }) => {

    const [rows, setRows] = useState<any[]>([]);
    const [annualUsage, setAnnualUsage] = useState<number>(0);
    const COLUMNS_PER_ROW = 2;


    const updateDailyUsage = (item: any, event: any) => {
        // update daily usage
        item.DailyUsage = Number(event.target.value);

        const year = new Date().getFullYear();
        const daysInMonth = getDaysInMonth(item.Month, year);
        // update monthly usage
        item.MonthUsage = item.DailyUsage * Number(daysInMonth);

        const data = DailyUsage?.Data || [];
        data.forEach((row: any) => {
            if (row.Month === item.Month) {
                row.DailyUsage = item.DailyUsage;
                row.MonthUsage = item.MonthUsage;
            }
        })
        const tempRows = [];
        for (let i = 0; i < data.length; i += COLUMNS_PER_ROW) {
            tempRows.push(data.slice(i, i + COLUMNS_PER_ROW));
        }
        setRows(tempRows);
        updateAnnualUsage(data);
    }

    const updateAnnualUsage = (data: any) => {
        let total = 0;
        rows.forEach((row) => {
            row.forEach((item: any) => {
                total += item.MonthUsage;
            })
        })
        setAnnualUsage(total);
        const dailyUsage = {
            AnnualUsage: total,
            Data: data
        }
        DailyUsageChange(dailyUsage);
    }

    const getDaysInMonth = (month: string, year: number) => {
        // Map month name to a zero-based index (January = 0, February = 1, etc.)
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        // Use indexOf to get the month index (0-11)
        const monthIndex = months.indexOf(month);

        // Check if the month name is valid
        if (monthIndex === -1) {
            return "Invalid month name";
        }

        // Create a new Date object for the first day of the *next* month
        // and set the day to 0, which results in the last day of the *current* month.
        // The month parameter in the Date constructor is 0-based, so we use monthIndex + 1.
        const date = new Date(year, monthIndex + 1, 0);

        // Use getDate() to return the day of the month, which is the total number of days
        // in the specified month.
        return date.getDate();
    }

    useEffect(() => {
        const data = DailyUsage?.Data || [];
        const tempRows = [];
        for (let i = 0; i < data.length; i += COLUMNS_PER_ROW) {
            tempRows.push(data.slice(i, i + COLUMNS_PER_ROW));
        }
        setRows(tempRows);
        setAnnualUsage(DailyUsage?.AnnualUsage);
    }, [DailyUsage]);

    return (
        <div className="obd-utility-popup__usage-table-wrap">
            <table className="obd-utility-usage-table">
                <thead>
                    <tr>
                        <th>Month</th>
                        <th>Daily usage</th>
                        <th>Monthly kWh</th>
                        <th>Month</th>
                        <th>Daily usage</th>
                        <th>Monthly kWh</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((item: any, index: number) => (
                                <React.Fragment key={index}>
                                    <td className="obd-utility-usage-table__month">{item.Month}</td>
                                    <td>
                                        <input type="text"
                                            className="obd-utility__input"
                                            value={item.DailyUsage}
                                            onChange={(e) => updateDailyUsage(item, e)}
                                            disabled={disabled} />
                                    </td>
                                    <td>
                                        <input type="text"
                                            className="obd-utility__input"
                                            value={item.MonthUsage} disabled />
                                    </td>
                                </React.Fragment>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>

            <Divider orientation="right">
                <span className='obd-utility__field-label'>
                    Total KW Usage: {annualUsage} kwh
                </span>
            </Divider>
        </div>
    );
};